import { Injectable } from '@angular/core';
import { logError } from './helpers/sentry.helper';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private savedUrl: string | null = null;

  constructor() {}

  public getSavedUrl(): string | null {
    if (!this.savedUrl) {
      logError('No saved url');
      return null;
    }
    return this.savedUrl;
  }

  public setSavedUrl(newUrl: string | null): void {
    this.savedUrl = newUrl;
  }
}
